import React from 'react';
import { useSelector } from 'react-redux';

import EmptyListing from 'src/components/EmptyListing/EmptyListing';
import ActionLink from 'src/components/EmptyListing/ActionLink';

import 'src/components/EmptyListing/ChosenEmptyListing.scss';


const ChosenEmptyListing = () => {
  const { searchFilterURL, profileURL } = useSelector(({ configReducer }) => ({
    searchFilterURL: configReducer.searchFilterURL,
    profileURL: configReducer.profileURL
  }));
  const emptyListingImage = useSelector(({ imagesReducer }) => imagesReducer.emptyListing);


  return (
    <EmptyListing
      copy={ (
        <div styleName="copy">
          <ActionLink href={ searchFilterURL } label="Zacznij szukać" />
          <ActionLink href={ profileURL } label="Uzupełnij profil" />
        </div>
      ) }
      header="Poznajmy się lepiej"
      hint="Przygotujemy dla Ciebie najlepsze oferty"
      image={ emptyListingImage }
      imageType="wide"
    />
  );
};


export default ChosenEmptyListing;
